import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

export default class Layout extends React.PureComponent<{}, { children?: React.ReactNode }> {
    public render() {
        return (
            <React.Fragment>
                {this.props.children}
            </React.Fragment >
        );
    }
}